"use client";

import Image from "next/image";
import {
  hideForDesktop,
  itemListTitle,
  toggleButtonContentContainer
} from "../Header/Menu/styles.css";
import { ChevronRightIcon } from "../../SVG";
import React from "react";
import {
  useTrackElementClicked,
  useTrackElementViewed
} from "packages/membership/tracking";

type MenuItem = {
  id: string;
  image:
    | undefined
    | {
        src: string;
        description: string;
      };
  title: string;
  href: string;
};

type Props = {
  recursionCount: number;
  item: MenuItem;
};

const baseTrackingValues = {
  target: "order_it_again",
  location: "navigation"
};

export function OrderItAgain({ recursionCount, item }: Props) {
  const { ref } = useTrackElementViewed({ ...baseTrackingValues });
  const { elementClicked } = useTrackElementClicked({ ...baseTrackingValues });

  return (
    <a
      ref={ref}
      href={item.href}
      track-click={`Nav${recursionCount + 1}`}
      onClick={() => {
        elementClicked({
          details: "order_it_again_link"
        });
      }}
    >
      {item.image ? (
        <>
          <Image
            src={item.image.src}
            alt={item.image.description}
            width={256}
            height={256}
          />
          <span className={`${toggleButtonContentContainer} ${itemListTitle}`}>
            <span className="text">{item.title}</span>
            <ChevronRightIcon className={hideForDesktop} />
          </span>
        </>
      ) : (
        <span className="text">{item.title}</span>
      )}
    </a>
  );
}
